export default __webpack_public_path__ + "static/media/sumergeLogo.31790830.png";